import IUserState from "../models/IUserState";
import IAddUser from '../../models/IAddUser';

export const initialState: IUserState = {
    userList: {
        users: [],
        error: null,
        loading: false,
    },
    addUser: {
        success: false,
        error: null,
        loading: false
    },
    deleteUser: {
        success: false,
        error: null,
        loading: false
    },
    user: {
        user: null,
        error: null,
        loading: false
    },
    userDevices: {
        devices: null,
        error: null,
        loading: false
    }
};


export const addUserInitialState: IAddUser = {
    UserName: '',
    UserType: true,
    Email: '',
    Password: '',
    ConfirmPassword: '',
    TimezoneId: 0,
    IsDefaultPassword: true
}
